module.exports = __webpack_public_path__ + "img/sld_mfm_t1_dark.ce47db26.svg";